import React, { useEffect } from 'react';
import { Button } from '../ui/Button';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../../stores/useAuthStore';
import { MARKETING_NS } from '../../i18n/marketingSegment';
import { canUseMarketingSegment, getSegment, rememberSegmentPath } from '../../utils/segment';
import SegmentSwitcher from './SegmentSwitcher';

/**
 * Barra superior do app: hoje, o seletor de segmento (Fashion | Marketing).
 * Também guarda a última rota de cada segmento para o seletor voltar de onde o
 * usuário parou. Só aparece para quem tem acesso ao segmento Marketing.
 */
const AppTopBar: React.FC = () => {
  const { t } = useTranslation(MARKETING_NS);
  const location = useLocation();
  const user = useAuthStore((s) => s.user);
  const segment = getSegment(location.pathname);
  const enabled = canUseMarketingSegment(user);

  useEffect(() => {
    if (enabled) rememberSegmentPath(segment, `${location.pathname}${location.search}`);
  }, [enabled, segment, location.pathname, location.search]);

  if (!enabled) return null;

  return (
    <div className="flex items-center gap-3 mb-4">
      {/* No Marketing a barra inferior do mobile (que é do Fashion) some; o menu abre por aqui. */}
      {segment === 'marketing' && (
        <Button
          type="button"
          variant="ghost"
          onClick={() => window.dispatchEvent(new CustomEvent('open-mobile-sidebar'))}
          aria-label={t('switcher.openMenu')}
          className="lg:hidden w-10 h-10 !p-0"
        >
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </Button>
      )}
      <SegmentSwitcher />
    </div>
  );
};

export default AppTopBar;
